import { twMerge } from "tailwind-merge";

const Label = ({...props}) => {
    return (
        <label {...props}  className={twMerge(`!block overflow-hidden text-gray-600 text-ellipsis text-[14px] font-normal leading-[153.846%]`, props.className)}>
            {props.children}
        </label>
    )
};

export default Label;